<div class="container">
    <div class="headerBackBtn" routerLink="/setting-camera">
        <img src="/assets/images/controlTowers/icon_back_blue.svg" height="15" width="15" alt="Imagen">
        <p class="titleback">{{"BACK" | translate}}</p>
    </div>
   
  
  </div>
  <div class="container" [formGroup]="filters">
      <!--<div class="close-btn-fill-area" mat-dialog-close>
          <span class="close-btn">
          </span>
      </div>
    -->
  
  
      <p class="title">{{"LABEL_NOTIFICATION_ALERT" | translate}}</p>
    <!--Filtros-->
    <div class="cardsContainer">
      <div class="card">
        <p class="textSelect">
           {{"incidentType" | translate}}
        </p>
        <div class="select">
            <mat-form-field color="white" appearance="outline">
                <mat-select #selIncidentType  formControlName="incidentType"  multiple>
  
                    <mat-select-trigger>
                        <span *ngIf="((filters.get('incidentType').value?.length || 0) == 1)">
                          {{ filters.get('incidentType').value[0]?.name || "SELECT_ALL" | translate }}
                        </span>
                        <span *ngIf="((filters.get('incidentType').value?.length || 0) > 1 && filters.get('incidentType').value[0]?.name !== undefined)">
                          {{ filters.get('incidentType').value[0]?.name || "SELECT_ALL" | translate }}
                        </span>
      
                        <span *ngIf="((filters.get('incidentType').value?.length || 0) > 1 && filters.get('incidentType').value[0]?.name == undefined)">
                          {{ filters.get('incidentType').value[1]?.name || "SELECT_ALL" | translate }}
                        </span>
      
                        <span *ngIf="((filters.get('incidentType').value?.length || 0) > 1)">
                          (+{{(filters.get('incidentType').value?.length || 0) - 1}} {{filters.get('incidentType')?.length === 2 ? '...' : '...'}})
                        </span>
                      </mat-select-trigger>
  
                    <mat-option (click)="toggleAllSelection(selIncidentType)" [value]="0">{{ "SELECT_ALL" | translate }}</mat-option>
                    <mat-option *ngFor="let option of arrayIncidentsTypes" [value]="option">{{option.name}}</mat-option>
                </mat-select>
              </mat-form-field>
  
        </div>
  
    </div>
      <div class="card">
          <p class="textSelect">
            {{"SEVERITY_ALERT" | translate}}
          </p>
          <div class="select">
              <mat-form-field color="white" appearance="outline">
                  <mat-select #selSeverityType formControlName="severityType"  multiple>
  
                      <mat-select-trigger>
                          <span *ngIf="((filters.get('severityType').value?.length || 0) == 1)">
                            {{ filters.get('severityType').value[0]?.name || "SELECT_ALL" | translate }}
                          </span>
                          <span *ngIf="((filters.get('severityType').value?.length || 0) > 1 && filters.get('severityType').value[0]?.name !== undefined)">
                            {{ filters.get('severityType').value[0]?.name || "SELECT_ALL" | translate }}
                          </span>
        
                          <span *ngIf="((filters.get('severityType').value?.length || 0) > 1 && filters.get('severityType').value[0]?.name == undefined)">
                            {{ filters.get('severityType').value[1]?.name || "SELECT_ALL" | translate }}
                          </span>
        
                          <span *ngIf="((filters.get('severityType').value?.length || 0) > 1)">
                            (+{{(filters.get('severityType').value?.length || 0) - 1}} {{filters.get('severityType')?.length === 2 ? '...' : '...'}})
                          </span>
                        </mat-select-trigger>
  
                      <mat-option (click)="toggleAllSelection(selSeverityType)" [value]="0">{{ "SELECT_ALL" | translate }}</mat-option>
                      <mat-option *ngFor="let option of arrayCodeSeverity" [value]="option">{{option.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
  
          </div>
          
          </div>
      </div>
  </div>
        
   <div class="container">
   <form [formGroup]="formAISettingCamera" (ngSubmit)="addArmingShedule()">
  <div class="checkbox-container">
      <p class="subtitle">{{"LABEL_ARMING" | translate}}:</p>
      <p class="subsubtitle">{{"LABEL_TITLE_PAUSE_ALERT" | translate}}:</p>
      <div class="checkbox-group">
          <label class="checkbox-label">
              <mat-checkbox formControlName="isvalidMonday" class="example-margin">{{"Monday" | translate}}</mat-checkbox>
              <!--<input type="checkbox" name="monday"> Monday-->
          </label>
          <label class="checkbox-label">
              <mat-checkbox class="example-margin" formControlName="isvalidTuesday">{{"Tuesday" | translate}}</mat-checkbox>
              <!--<input type="checkbox" name="tuesday"> Tuesday-->
          </label>
          <label class="checkbox-label">
              <mat-checkbox class="example-margin" formControlName="isvalidWednesday">{{"Wednesday" | translate}}</mat-checkbox>
              <!--<input type="checkbox" name="wednesday"> Wednesday-->
          </label>
          <label class="checkbox-label">
              <mat-checkbox class="example-margin" formControlName="isvalidThursDay">{{"Thursday" | translate}}</mat-checkbox>
              <!--<input type="checkbox" name="thursday"> Thursday-->
          </label>
          <label class="checkbox-label">
              <mat-checkbox class="example-margin" formControlName="isvalidFriday">{{"Friday" | translate}}</mat-checkbox>
              <!--<input type="checkbox" name="friday"> Friday-->
          </label>
          <label class="checkbox-label">
              <mat-checkbox class="example-margin" formControlName="isvalidSaturday">{{"Saturday" | translate}}</mat-checkbox>
              <!--<input type="checkbox" name="saturday"> Saturday-->
          </label>
          <label class="checkbox-label">
              <mat-checkbox class="example-margin" formControlName="isvalidSunday">{{"Sunday" | translate}}</mat-checkbox>
              <!--<input type="checkbox" name="sunday"> Sunday-->
          </label>
      </div>
  </div>
  
  
  
  
  <div class="radio-container">
      <p class="subtitle">{{"LABEL_RANGE_TIME" | translate}}:</p>
      <p class="subsubtitle">{{"SELECT_TIME_ALERT" | translate}}:</p>
      <div class="radio-group">
  
          <mat-radio-group formControlName="options">
              <mat-radio-button  value="1">{{"LABELALWAYS" | translate}}</mat-radio-button>
              <mat-radio-button value="2">{{"LABEL_FROM" | translate}}</mat-radio-button>
              
              
                  <input formControlName="from" style="margin-left: 10px;cursor: pointer;" type="time" id="from-time" name="from-time">
                  <label style="margin-left: 10px;" for="to-time">{{"LABEL_TO" | translate}}:</label>
                  <input formControlName="to" style="cursor: pointer;" type="time" id="to-time" name="to-time">
              
          </mat-radio-group>
        
      </div>
      
     
  </div>
  
  
  
  
  
   
  
  
  <div class="radio-container">
    
  
    <p class="subtitle">{{"LABEL_ALERT_TYPE" | translate}}:</p>
  
      <p class="subsubtitle">{{"LABEL_RECIPIENT_ALERT" | translate}}:</p>
      <div class="radio-group">
          <!--<mat-radio-group formControlName="optionAlert" aria-label="Select an option">
              <mat-radio-button value="1" (change)="radioChange($event)">{{ "LABEL_EMAIL" | translate}}</mat-radio-button>
              <mat-radio-button value="2" (change)="radioChange($event)">{{ "LABEL_WHATS" | translate}}</mat-radio-button>
              
              <mat-radio-button value="3">SMS</mat-radio-button>
            
             
                           
          </mat-radio-group>-->
          
          
          <mat-form-field  appearance="outline" color="white" class="matformSelect">
            
            <mat-select  formControlName="alarmType" (selectionChange)="radioChange($event)">
            
              <mat-option *ngFor="let option of arrayTypesAlert" [value]="option.id">{{option.name}}</mat-option>
     
              <!--<mat-option [value]="1">{{ "LABEL_EMAIL" | translate}}</mat-option>
              <mat-option [value]="2">{{ "LABEL_WHATS" | translate}}</mat-option>
  
              <mat-option [value]="13206">STROBE SIREN</mat-option>
              <mat-option [value]="13205">SPEAKER</mat-option>
              <mat-option [value]="13207">I4Safety Notification</mat-option>-->
              
             
            </mat-select>
   
          </mat-form-field>
        
      </div>
  
  
    
  </div>
  
  
  
  
  
  <div *ngIf="IsVisibleEmail || IsVisibleWhatsApp">
      <mat-form-field class="box_width">
          <mat-label *ngIf="IsVisibleEmail">{{ "LABEL_EMAIL" | translate}}</mat-label>
          <mat-label *ngIf="IsVisibleWhatsApp">{{ "LABEL_WHATS" | translate}}</mat-label>
          <mat-chip-grid  #chipGrid  aria-label="Fruit selection">
            @for (cont of contact(); track $index) {
              <mat-chip-row *ngIf="(cont) && (IsVisibleEmail);else second" (removed)="remove(cont)">
                {{cont}}
                <button matChipRemove [attr.aria-label]="'remove ' + cont">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
              <ng-template #second>
                  <mat-chip-row *ngIf="(cont) && (IsVisibleWhatsApp);else third" (removed)="remove(cont)">
                {{cont}}
                <button matChipRemove [attr.aria-label]="'remove ' + cont">
                  <mat-icon>cancel</mat-icon>
                </button>
                  </mat-chip-row>
              </ng-template>
              <!--<ng-template #third>
                  <mat-chip-row *ngIf="(cont)" (removed)="remove(cont)">
                      {{cont.sirene}}
                      <button matChipRemove [attr.aria-label]="'remove ' + 'hhhh'">
                        <mat-icon>cancel</mat-icon>
                      </button>
                  </mat-chip-row>
              </ng-template>-->
            }
          </mat-chip-grid>
          <input
            name="currentFruit"
            placeholder="search.."
            #fruitInput
           formControlName="currentFruit"
            [matChipInputFor]="chipGrid"
            [matAutocomplete]="auto"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)"
          />
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            @for (fruit of filteredFruits(); track fruit.email) {
              <mat-option *ngIf="IsVisibleEmail" [value]="fruit">{{fruit.email}}</mat-option>
              <mat-option *ngIf="IsVisibleWhatsApp && fruit.whatsapp != null" [value]="fruit">{{fruit.whatsapp}}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
  </div>
  
  <div>
   
    <!--<p class="subsubtitle">{{"LABEL_SELECTED_TEMPLATE" | translate}}:</p>
    <mat-form-field appearance="outline" color="white" class="matformSelect">
   
    <mat-select formControlName="template" (selectionChange)="checkValue($event.source.triggerValue)">
    
      <mat-option *ngFor="let option of filteredItems" [value]="option.id">{{option.name}}</mat-option>
     
    </mat-select>
   
  </mat-form-field>-->
    
  </div>
  
  
  <div class="headerCreateBtn">
      <button  mat-raised-button color="primary">
            
          {{ 'LABEL_ADD_ALERT' | translate}}
          
        </button>
      </div>
  
  </form>
  <div class="divTable">
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8">
  
      
          <!-- Name Column -->
          <ng-container matColumnDef="days">
              <th mat-header-cell *matHeaderCellDef> {{ "LABEL_DAYS" | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.days}} </td>
          </ng-container>
      
          <ng-container matColumnDef="from">
              <th mat-header-cell *matHeaderCellDef> {{ "LABEL_FROM" | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.from}} </td>
          </ng-container>
      
          <ng-container matColumnDef="to">
              <th mat-header-cell *matHeaderCellDef> {{ "LABEL_TO" | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.to}} </td>
          </ng-container>
  
          <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef>{{ "LABEL_DELETE_ALERT" | translate }}</th>
              <td mat-cell *matCellDef="let element"> 
                  <button mat-icon-button class="removeCart" (click)="openConfirmDialog(element)" >
                     <mat-icon>close</mat-icon>
                  </button>
              </td>
             
          </ng-container>
  
          <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsChildren.length">
                 <div class="example-element-detail"
                      [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'" *ngIf="element.recordStatus === I_INVALID_RECORD_INDICATOR">
  
                       <table  width="100%">
                          <thead>
                              <tr>
                                <th scope="col">Alert</th>
                                <th scope="col">Type Alert</th>
                              </tr>
                          </thead>
                             <tr *ngFor="let i of element.typeAlert">
                                <!--<td align="left">{{element.typeAlert[0].emails}} </td>-->
                                  <td align="left">{{i.alerts}} </td>
                                  <td align="left">{{i.typeAlert}} </td>
                            </tr>
                           
                     </table>
                 </div>
              </td>
           </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns;"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element">
          </tr>
          <!--<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        </table>
  </div>
  
  
  
  
  <table class="full-width-table"  cellspacing="0">
      <tr>
      <td style="text-align: center;">
          <button class="matbtnTransparent" mat-stroked-button (click)="close()">
            
              {{ 'DIALOG_BACK_CANCEL' | translate}}
              
          </button>
      </td>
      <td style="text-align: center;">
          <button mat-raised-button color="primary"  (click)="validateSeverityAndEventTypeAlert()">
            
            {{ 'SAVE' | translate}}
              
          </button>
      </td>
    </tr></table>
  
  
  </div>
  
